import React, { useState, useEffect } from "react";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import { useNavigate, useLocation } from "react-router-dom";

//Components
import Layout from "../../../Layout/Layout";
import ItemService from "../../../services/supplier_appCommonService";
import SupplierConstants from "../../../common/SupplierConstants";
import { budgetFieldLabels } from "./budgetConstants";

const BudgetCreationDetails = () => {
  const navigate = useNavigate();
  const location = useLocation();

  localStorage.setItem("menu", "Admin");
  localStorage.setItem("submenu", "Budget");

  const budgetId =
    location?.state?.budgetId || new URLSearchParams(location.search).get("id");

  const [isCardVisible, setCardVisible] = useState(true);
  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };

  const [budgetData, setBudgetData] = useState(null);
  const [getIsPageLoading, setIsPageLoading] = useState(true);

  useEffect(() => {
    if (budgetId) {
      loadBudgetDetail(budgetId);
    } else {
      navigate(SupplierConstants.BUDGET_LIST);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [budgetId]);

  const loadBudgetDetail = async (id) => {
    setIsPageLoading(true);
    try {
      await ItemService.getBudgetDetail({ _id: id }).then((item) => {
        if (item?.status === 200 && item?.data) {
          setBudgetData(item.data);
        } else {
          toast.error(item?.message || "!! Unable to Get Budget Detail");
          navigate(SupplierConstants.BUDGET_LIST);
        }
      });
    } catch (error) {
      console.log("loadBudgetDetail Failed:", error);
      toast.error("!! Unable to Get Budget Detail");
      navigate(SupplierConstants.BUDGET_LIST);
    }
    setIsPageLoading(false);
  };

  const handleEdit = () => {
    navigate(SupplierConstants.BUDGET_CREATE, { state: { budgetId: budgetId } });
  };

  const handleBack = () => {
    navigate(SupplierConstants.BUDGET_LIST);
  };

  const formatDate = (value) => {
    if (!value) return "-";
    try {
      let d = new Date(value);
      if (isNaN(d)) return value;
      return d.toLocaleDateString("en-GB", {
        day: "2-digit",
        month: "short",
        year: "numeric",
      });
    } catch (e) {
      return value;
    }
  };

  const formatAmount = (amount, currency) => {
    let num = Number(amount || 0);
    return (currency || "INR") + " " + num.toLocaleString("en-IN");
  };

  const DetailRow = ({ label, value }) => (
    <Row className="mb-2">
      <Col xs={12} md={5} lg={5}>
        <span className="fw-semibold text-gray-700">{label}</span>
      </Col>
      <Col xs={12} md={7} lg={7}>
        <span className="text-gray-600">{value || "-"}</span>
      </Col>
    </Row>
  );

  const orderedFields = [
    "documentNumber",
    "budgetName",
    "company",
    "businessUnit",
    "category",
    "department",
    "costCenter",
    "financialYear",
    "budgetPeriod",
    "budgetAmount",
    "currency",
    "startDate",
    "endDate",
    "description",
    "status",
  ];

  const renderValue = (key) => {
    const value = budgetData?.[key];
    if (key === "budgetAmount") {
      return formatAmount(value, budgetData?.currency);
    }
    if (key === "startDate" || key === "endDate") {
      return formatDate(value);
    }
    if (key === "status") {
      return (
        <span
          className={`badge ${
            value === "Active" || value === "Approved"
              ? "bg-success"
              : value === "Rejected"
              ? "bg-danger"
              : "bg-secondary"
          }`}
        >
          {value || "Draft"}
        </span>
      );
    }
    return value || "-";
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <Row>
              <Col xs={8} md={9} lg={9} className="mb-2">
                <h2 className="mainTitle">Budget Details</h2>
                <p className="subText">Budget Creation Details</p>
              </Col>
              <Col
                xs={4}
                md={3}
                lg={3}
                className="mb-2 d-flex justify-content-end align-items-center gap-2"
              >
                <button className="btnTable" onClick={handleBack}>
                  <i className="bi bi-arrow-left me-1"></i> Back
                </button>
                <button className="btnTable" onClick={handleEdit}>
                  <i className="bi bi-pencil-square me-1"></i> Edit
                </button>
              </Col>
              <hr />
            </Row>

            <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible ? "bi-chevron-right" : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">BD</span>
                    </Col>
                    <Col xs={12} md={8} lg={8}>
                      <span className="headerTitle">Budget Information</span>
                      <span className="subHeaderTitle">
                        {budgetData?.documentNumber || "Budget Details"}
                      </span>
                    </Col>
                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    {getIsPageLoading ? (
                      <div className="text-center p-5">Loading...</div>
                    ) : (
                      <Row className="pt-2 pb-4">
                        <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
                          {orderedFields.slice(0, 8).map((key) => (
                            <DetailRow
                              key={key}
                              label={budgetFieldLabels[key]}
                              value={renderValue(key)}
                            />
                          ))}
                        </Col>
                        <Col xs={12} md={6} lg={6} className="commTopButtonRightLeftPadding">
                          {orderedFields.slice(8).map((key) => (
                            <DetailRow
                              key={key}
                              label={budgetFieldLabels[key]}
                              value={renderValue(key)}
                            />
                          ))}
                        </Col>
                      </Row>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </main>
  );
};

export default BudgetCreationDetails;
